export const redteamPosts = [
  {
    id: 'rt1',
    user_id: 'user156',
    type: 'feed' as const,
    category: 'redteam',
    title: '금융권 레드팀 작전 후기 - 72시간 만에 도메인 장악',
    content: '대형 금융기관 레드팀 작전에서 72시간 만에 도메인 컨트롤러를 장악한 경험을 공유합니다. 초기 침투부터 권한 상승, 횡적 이동, 그리고 최종 목표 달성까지의 전 과정을 상세히 설명합니다. OPSEC 유지와 탐지 회피 기법도 다룹니다.',
    tags: ['redteam', 'finance', 'domain-admin', 'opsec', 'engagement'],
    status: 'open',
    is_pinned: false,
    likes_count: 3234,
    replies_count: 117,
    views_count: 26700,
    created_at: new Date(Date.now() - 1 * 3600000).toISOString(),
    profiles: {
      id: 'user156',
      username: 'redteam_lead',
      display_name: 'Red Team Lead',
      points: 19870,
      reputation: 6120
    }
  },
  {
    id: 'rt2',
    user_id: 'user157',
    type: 'feed' as const,
    category: 'redteam',
    title: 'EDR 우회 기법 2025 - 최신 탐지 솔루션 무력화',
    content: 'CrowdStrike, SentinelOne, Microsoft Defender 등 최신 EDR 솔루션을 우회하는 기법을 공유합니다. 시스템 콜 후킹 우회, ETW 패치, AMSI 무력화 등 실전에서 검증된 방법들을 다룹니다. 각 EDR별 특성과 우회 전략도 분석합니다.',
    tags: ['redteam', 'edr-evasion', 'bypass', 'crowdstrike', 'defender'],
    status: 'open',
    is_pinned: false,
    likes_count: 4123,
    replies_count: 156,
    views_count: 34200,
    created_at: new Date(Date.now() - 3 * 3600000).toISOString(),
    profiles: {
      id: 'user157',
      username: 'evasion_expert',
      display_name: 'Evasion Expert',
      points: 21450,
      reputation: 6780
    }
  },
  {
    id: 'rt3',
    user_id: 'user158',
    type: 'feed' as const,
    category: 'redteam',
    title: 'Cobalt Strike 대안 - Sliver C2 실전 활용기',
    content: 'Cobalt Strike의 오픈소스 대안인 Sliver C2를 실제 레드팀 작전에서 활용한 경험을 공유합니다. 설치부터 커스터마이징, 실전 운용까지 전 과정을 다룹니다. Cobalt Strike와의 비교 분석과 함께 장단점을 솔직하게 평가합니다.',
    tags: ['redteam', 'sliver', 'c2', 'cobalt-strike', 'opensource'],
    status: 'open',
    is_pinned: false,
    likes_count: 2876,
    replies_count: 104,
    views_count: 23400,
    created_at: new Date(Date.now() - 5 * 3600000).toISOString(),
    profiles: {
      id: 'user158',
      username: 'c2_operator',
      display_name: 'C2 Operator',
      points: 18230,
      reputation: 5670
    }
  },
  {
    id: 'rt4',
    user_id: 'user159',
    type: 'feed' as const,
    category: 'redteam',
    title: 'Active Directory 공격 체인 - Kerberoasting부터 Golden Ticket까지',
    content: 'Active Directory 환경에서 일반 사용자 권한으로 시작하여 Domain Admin까지 상승하는 전체 공격 체인을 설명합니다. Kerberoasting, AS-REP Roasting, DCSync, Golden Ticket 등 핵심 기법들을 실전 시나리오와 함께 다룹니다.',
    tags: ['redteam', 'active-directory', 'kerberos', 'golden-ticket', 'privilege-escalation'],
    status: 'open',
    is_pinned: false,
    likes_count: 3456,
    replies_count: 128,
    views_count: 28900,
    created_at: new Date(Date.now() - 7 * 3600000).toISOString(),
    profiles: {
      id: 'user159',
      username: 'ad_attacker',
      display_name: 'AD Attacker',
      points: 17890,
      reputation: 5450
    }
  },
  {
    id: 'rt5',
    user_id: 'user160',
    type: 'feed' as const,
    category: 'redteam',
    title: '피싱 캠페인 설계 - 99% 성공률 달성 전략',
    content: '레드팀 작전에서 99% 성공률을 기록한 피싱 캠페인 설계 노하우를 공유합니다. 타겟 분석, 시나리오 작성, 메일 템플릿 제작, 그리고 랜딩 페이지 구축까지 전 과정을 다룹니다. 윤리적 고려사항과 법적 경계도 함께 논의합니다.',
    tags: ['redteam', 'phishing', 'social-engineering', 'campaign', 'success'],
    status: 'open',
    is_pinned: false,
    likes_count: 2789,
    replies_count: 98,
    views_count: 22700,
    created_at: new Date(Date.now() - 9 * 3600000).toISOString(),
    profiles: {
      id: 'user160',
      username: 'phishing_master',
      display_name: 'Phishing Master',
      points: 16670,
      reputation: 5120
    }
  },
  {
    id: 'rt6',
    user_id: 'user161',
    type: 'feed' as const,
    category: 'redteam',
    title: '클라우드 레드팀 - AWS 환경 침투 테스트',
    content: 'AWS 클라우드 환경에서의 레드팀 작전 경험을 공유합니다. IAM 권한 상승, S3 버킷 탈취, Lambda 백도어, 그리고 EC2 인스턴스 장악까지 클라우드 특유의 공격 벡터를 다룹니다. 실전 시나리오와 함께 탐지 회피 기법도 설명합니다.',
    tags: ['redteam', 'aws', 'cloud', 'iam', 'privilege-escalation'],
    status: 'open',
    is_pinned: false,
    likes_count: 3123,
    replies_count: 108,
    views_count: 25600,
    created_at: new Date(Date.now() - 11 * 3600000).toISOString(),
    profiles: {
      id: 'user161',
      username: 'cloud_redteam',
      display_name: 'Cloud Red Team',
      points: 17450,
      reputation: 5340
    }
  },
  {
    id: 'rt7',
    user_id: 'user162',
    type: 'feed' as const,
    category: 'redteam',
    title: 'Living Off The Land - 시스템 기본 도구만으로 공격하기',
    content: 'LOLBAS(Living Off The Land Binaries and Scripts) 기법을 활용한 레드팀 작전을 공유합니다. PowerShell, WMI, certutil 등 시스템 기본 도구만으로 전체 공격 체인을 구성하는 방법을 설명합니다. 탐지 회피에 매우 효과적입니다.',
    tags: ['redteam', 'lolbas', 'powershell', 'fileless', 'evasion'],
    status: 'open',
    is_pinned: false,
    likes_count: 2567,
    replies_count: 92,
    views_count: 20800,
    created_at: new Date(Date.now() - 13 * 3600000).toISOString(),
    profiles: {
      id: 'user162',
      username: 'lolbas_ninja',
      display_name: 'LOLBAS Ninja',
      points: 15230,
      reputation: 4680
    }
  },
  {
    id: 'rt8',
    user_id: 'user163',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 인프라 구축 - 안전하고 확장 가능한 C2 설계',
    content: '레드팀 작전을 위한 인프라 구축 경험을 공유합니다. 리다이렉터 설정, 도메인 프론팅, CDN 활용, 그리고 C2 서버 보안까지 전체 아키텍처를 설명합니다. 비용 효율적이면서도 안전한 인프라 구축 노하우를 다룹니다.',
    tags: ['redteam', 'infrastructure', 'c2', 'redirector', 'opsec'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 103,
    views_count: 23400,
    created_at: new Date(Date.now() - 15 * 3600000).toISOString(),
    profiles: {
      id: 'user163',
      username: 'infra_architect',
      display_name: 'Infra Architect',
      points: 16230,
      reputation: 4980
    }
  },
  {
    id: 'rt9',
    user_id: 'user164',
    type: 'feed' as const,
    category: 'redteam',
    title: '내부망 횡적 이동 - BloodHound 활용 전략',
    content: 'BloodHound를 활용한 효율적인 횡적 이동 전략을 공유합니다. 그래프 분석으로 최단 공격 경로를 찾고, 고가치 타겟을 식별하는 방법을 설명합니다. 실제 작전에서 사용한 커스텀 Cypher 쿼리와 자동화 스크립트도 제공합니다.',
    tags: ['redteam', 'bloodhound', 'lateral-movement', 'active-directory', 'graph'],
    status: 'open',
    is_pinned: false,
    likes_count: 2678,
    replies_count: 94,
    views_count: 21800,
    created_at: new Date(Date.now() - 17 * 3600000).toISOString(),
    profiles: {
      id: 'user164',
      username: 'bloodhound_pro',
      display_name: 'BloodHound Pro',
      points: 14890,
      reputation: 4560
    }
  },
  {
    id: 'rt10',
    user_id: 'user165',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 vs 블루팀 - Purple Team 훈련 후기',
    content: 'Purple Team 훈련에서 레드팀과 블루팀이 협력한 경험을 공유합니다. 공격 시나리오 설계, 탐지 룰 개선, 그리고 상호 학습 과정을 다룹니다. 조직의 전체적인 보안 수준을 높이는 Purple Team 방법론을 설명합니다.',
    tags: ['redteam', 'blueteam', 'purple-team', 'training', 'collaboration'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 89,
    views_count: 19700,
    created_at: new Date(Date.now() - 19 * 3600000).toISOString(),
    profiles: {
      id: 'user165',
      username: 'purple_team',
      display_name: 'Purple Team Lead',
      points: 16450,
      reputation: 5010
    }
  },
  {
    id: 'rt11',
    user_id: 'user166',
    type: 'feed' as const,
    category: 'redteam',
    title: 'Windows Defender 완벽 우회 - 2025년 최신 기법',
    content: 'Windows Defender의 최신 보호 기능을 우회하는 방법을 공유합니다. 실시간 보호, 클라우드 기반 탐지, 행위 기반 차단을 모두 우회하는 기법을 다룹니다. 실전에서 검증된 페이로드 난독화와 실행 기법을 설명합니다.',
    tags: ['redteam', 'windows-defender', 'bypass', 'av-evasion', 'payload'],
    status: 'open',
    is_pinned: false,
    likes_count: 3234,
    replies_count: 112,
    views_count: 26400,
    created_at: new Date(Date.now() - 21 * 3600000).toISOString(),
    profiles: {
      id: 'user166',
      username: 'av_bypasser',
      display_name: 'AV Bypasser',
      points: 17230,
      reputation: 5340
    }
  },
  {
    id: 'rt12',
    user_id: 'user167',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 리포트 작성 - 경영진 설득 전략',
    content: '레드팀 작전 결과를 효과적으로 전달하는 리포트 작성법을 공유합니다. 기술적 상세와 비즈니스 영향을 균형있게 표현하고, 경영진을 설득하여 보안 투자를 이끌어내는 방법을 설명합니다. 실제 리포트 샘플도 제공합니다.',
    tags: ['redteam', 'reporting', 'communication', 'executive', 'documentation'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 78,
    views_count: 17200,
    created_at: new Date(Date.now() - 23 * 3600000).toISOString(),
    profiles: {
      id: 'user167',
      username: 'report_writer',
      display_name: 'Report Writer',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 'rt13',
    user_id: 'user168',
    type: 'feed' as const,
    category: 'redteam',
    title: 'Kubernetes 클러스터 장악 - 컨테이너 탈출부터 노드 제어까지',
    content: 'Kubernetes 환경에서의 레드팀 작전을 공유합니다. 잘못 설정된 RBAC 권한 악용, 컨테이너 탈출, 그리고 노드 장악까지의 전 과정을 설명합니다. 클라우드 네이티브 환경의 독특한 공격 벡터와 방어 전략을 다룹니다.',
    tags: ['redteam', 'kubernetes', 'container-escape', 'rbac', 'cloud-native'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 101,
    views_count: 23700,
    created_at: new Date(Date.now() - 25 * 3600000).toISOString(),
    profiles: {
      id: 'user168',
      username: 'k8s_attacker',
      display_name: 'K8s Attacker',
      points: 16890,
      reputation: 5120
    }
  },
  {
    id: 'rt14',
    user_id: 'user169',
    type: 'feed' as const,
    category: 'redteam',
    title: '물리적 침투 테스트 - 사무실 침입부터 네트워크 접근까지',
    content: '물리적 보안 테스트 경험을 공유합니다. 출입 통제 우회, 사회공학 기법, 그리고 내부 네트워크 접근까지의 과정을 설명합니다. 드롭박스 설치, 배지 복제, 테일게이팅 등 실전 기법을 다룹니다. 법적 경계와 윤리적 고려사항도 논의합니다.',
    tags: ['redteam', 'physical-security', 'social-engineering', 'access-control', 'dropbox'],
    status: 'open',
    is_pinned: false,
    likes_count: 2678,
    replies_count: 96,
    views_count: 21900,
    created_at: new Date(Date.now() - 27 * 3600000).toISOString(),
    profiles: {
      id: 'user169',
      username: 'physical_tester',
      display_name: 'Physical Tester',
      points: 15670,
      reputation: 4780
    }
  },
  {
    id: 'rt15',
    user_id: 'user170',
    type: 'feed' as const,
    category: 'redteam',
    title: 'Mimikatz 대안 - 크리덴셜 덤핑 최신 기법',
    content: 'Mimikatz가 탐지되는 환경에서 사용할 수 있는 대안 기법들을 공유합니다. Pypykatz, SharpKatz, 그리고 직접 LSASS 메모리를 읽는 방법까지 다양한 크리덴셜 덤핑 기법을 설명합니다. EDR 탐지를 회피하는 실전 노하우를 다룹니다.',
    tags: ['redteam', 'mimikatz', 'credential-dumping', 'lsass', 'alternatives'],
    status: 'open',
    is_pinned: false,
    likes_count: 3123,
    replies_count: 108,
    views_count: 25600,
    created_at: new Date(Date.now() - 29 * 3600000).toISOString(),
    profiles: {
      id: 'user170',
      username: 'cred_dumper',
      display_name: 'Credential Dumper',
      points: 17450,
      reputation: 5340
    }
  },
  {
    id: 'rt16',
    user_id: 'user171',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 도구 개발 - 커스텀 임플란트 제작기',
    content: '상용 도구에 의존하지 않고 커스텀 임플란트를 개발한 경험을 공유합니다. C2 프로토콜 설계, 암호화 통신, 모듈화 구조 등 전체 아키텍처를 설명합니다. Rust로 작성한 크로스 플랫폼 임플란트의 소스코드도 일부 공개합니다.',
    tags: ['redteam', 'tool-development', 'implant', 'c2', 'rust'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 103,
    views_count: 23400,
    created_at: new Date(Date.now() - 31 * 3600000).toISOString(),
    profiles: {
      id: 'user171',
      username: 'tool_developer',
      display_name: 'Tool Developer',
      points: 18230,
      reputation: 5670
    }
  },
  {
    id: 'rt17',
    user_id: 'user172',
    type: 'feed' as const,
    category: 'redteam',
    title: 'SIEM 탐지 회피 - 로그 분석 시스템 우회 전략',
    content: 'Splunk, ELK, QRadar 등 SIEM 시스템의 탐지를 회피하는 전략을 공유합니다. 로그 생성 최소화, 정상 트래픽 모방, 타이밍 조절 등 OPSEC 관점에서의 접근법을 설명합니다. 실제 작전에서 탐지되지 않았던 기법들을 다룹니다.',
    tags: ['redteam', 'siem', 'log-evasion', 'opsec', 'detection'],
    status: 'open',
    is_pinned: false,
    likes_count: 2567,
    replies_count: 91,
    views_count: 20800,
    created_at: new Date(Date.now() - 33 * 3600000).toISOString(),
    profiles: {
      id: 'user172',
      username: 'siem_evader',
      display_name: 'SIEM Evader',
      points: 15890,
      reputation: 4890
    }
  },
  {
    id: 'rt18',
    user_id: 'user173',
    type: 'feed' as const,
    category: 'redteam',
    title: 'Azure AD 레드팀 - 하이브리드 환경 공격',
    content: 'Azure AD와 온프레미스 AD가 연동된 하이브리드 환경에서의 레드팀 작전을 공유합니다. Azure AD Connect 악용, Pass-Through Authentication 공격, 그리고 클라우드에서 온프레미스로의 역방향 공격까지 다룹니다.',
    tags: ['redteam', 'azure-ad', 'hybrid', 'cloud', 'active-directory'],
    status: 'open',
    is_pinned: false,
    likes_count: 2789,
    replies_count: 98,
    views_count: 22700,
    created_at: new Date(Date.now() - 35 * 3600000).toISOString(),
    profiles: {
      id: 'user173',
      username: 'azure_redteam',
      display_name: 'Azure Red Team',
      points: 16670,
      reputation: 5120
    }
  },
  {
    id: 'rt19',
    user_id: 'user174',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 자동화 - 공격 워크플로우 스크립팅',
    content: '반복적인 레드팀 작업을 자동화한 경험을 공유합니다. 정찰부터 익스플로잇, 후속 공격까지 전체 워크플로우를 자동화하는 방법을 설명합니다. Python과 PowerShell로 작성한 자동화 프레임워크를 오픈소스로 공개합니다.',
    tags: ['redteam', 'automation', 'scripting', 'workflow', 'efficiency'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 87,
    views_count: 19900,
    created_at: new Date(Date.now() - 37 * 3600000).toISOString(),
    profiles: {
      id: 'user174',
      username: 'automation_expert',
      display_name: 'Automation Expert',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'rt20',
    user_id: 'user175',
    type: 'feed' as const,
    category: 'redteam',
    title: 'VPN 우회 - 네트워크 세그멘테이션 돌파',
    content: '엄격한 네트워크 세그멘테이션 환경에서 VPN을 우회하고 내부망에 접근한 경험을 공유합니다. Split tunneling 악용, DNS 터널링, 그리고 프록시 체인 구성 등 다양한 우회 기법을 설명합니다.',
    tags: ['redteam', 'vpn', 'network-segmentation', 'tunneling', 'bypass'],
    status: 'open',
    is_pinned: false,
    likes_count: 2234,
    replies_count: 82,
    views_count: 18100,
    created_at: new Date(Date.now() - 39 * 3600000).toISOString(),
    profiles: {
      id: 'user175',
      username: 'network_ninja',
      display_name: 'Network Ninja',
      points: 15450,
      reputation: 4680
    }
  },
  {
    id: 'rt21',
    user_id: 'user176',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 멘탈 관리 - 장기 작전에서의 스트레스 대처',
    content: '수개월간 진행되는 장기 레드팀 작전에서의 멘탈 관리 경험을 공유합니다. 탐지 위험에 대한 스트레스, 팀원 간 갈등, 그리고 번아웃 예방 방법을 다룹니다. 건강한 레드팀 문화 구축의 중요성도 강조합니다.',
    tags: ['redteam', 'mental-health', 'stress', 'teamwork', 'culture'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 71,
    views_count: 15300,
    created_at: new Date(Date.now() - 41 * 3600000).toISOString(),
    profiles: {
      id: 'user176',
      username: 'team_wellness',
      display_name: 'Team Wellness',
      points: 12670,
      reputation: 3890
    }
  },
  {
    id: 'rt22',
    user_id: 'user177',
    type: 'feed' as const,
    category: 'redteam',
    title: 'macOS 레드팀 - Apple 환경 공격 기법',
    content: 'macOS 환경에서의 레드팀 작전 경험을 공유합니다. Gatekeeper 우회, SIP 무력화, 키체인 접근, 그리고 지속성 확보까지 macOS 특유의 공격 기법을 설명합니다. Windows 중심 도구들을 macOS에 적용하는 방법도 다룹니다.',
    tags: ['redteam', 'macos', 'gatekeeper', 'sip', 'apple'],
    status: 'open',
    is_pinned: false,
    likes_count: 2678,
    replies_count: 93,
    views_count: 21700,
    created_at: new Date(Date.now() - 43 * 3600000).toISOString(),
    profiles: {
      id: 'user177',
      username: 'mac_redteam',
      display_name: 'Mac Red Team',
      points: 16450,
      reputation: 5010
    }
  },
  {
    id: 'rt23',
    user_id: 'user178',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 교육 프로그램 - 신입 양성 커리큘럼',
    content: '레드팀 신입을 양성하는 교육 프로그램을 설계한 경험을 공유합니다. 6개월 커리큘럼, 실습 환경 구축, 평가 방법, 그리고 멘토링 전략을 다룹니다. 효과적인 레드팀 인력 양성 노하우를 제공합니다.',
    tags: ['redteam', 'training', 'education', 'curriculum', 'mentoring'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 78,
    views_count: 17200,
    created_at: new Date(Date.now() - 45 * 3600000).toISOString(),
    profiles: {
      id: 'user178',
      username: 'redteam_trainer',
      display_name: 'Red Team Trainer',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'rt24',
    user_id: 'user179',
    type: 'feed' as const,
    category: 'redteam',
    title: 'OT/ICS 환경 레드팀 - 산업 제어 시스템 보안 테스트',
    content: '산업 제어 시스템(ICS) 환경에서의 레드팀 작전을 공유합니다. SCADA 시스템 접근, PLC 조작, 그리고 물리적 프로세스 영향까지 OT 환경의 독특한 공격 벡터를 설명합니다. 안전을 최우선으로 하는 테스트 방법론을 강조합니다.',
    tags: ['redteam', 'ot', 'ics', 'scada', 'industrial'],
    status: 'open',
    is_pinned: false,
    likes_count: 2890,
    replies_count: 101,
    views_count: 23400,
    created_at: new Date(Date.now() - 47 * 3600000).toISOString(),
    profiles: {
      id: 'user179',
      username: 'ot_redteam',
      display_name: 'OT Red Team',
      points: 17890,
      reputation: 5450
    }
  },
  {
    id: 'rt25',
    user_id: 'user180',
    type: 'feed' as const,
    category: 'redteam',
    title: '레드팀 2025 트렌드 - AI 기반 공격과 방어',
    content: '2025년 레드팀의 새로운 트렌드를 분석합니다. AI를 활용한 자동화된 공격, LLM 기반 피싱, 그리고 AI 보안 솔루션 우회 기법을 다룹니다. 미래 레드팀의 모습과 필요한 역량을 전망합니다.',
    tags: ['redteam', 'ai', 'automation', '2025', 'future'],
    status: 'open',
    is_pinned: false,
    likes_count: 3456,
    replies_count: 127,
    views_count: 28200,
    created_at: new Date(Date.now() - 49 * 3600000).toISOString(),
    profiles: {
      id: 'user180',
      username: 'future_redteam',
      display_name: 'Future Red Team',
      points: 19230,
      reputation: 5890
    }
  }
];